'use strict';

define('componentAllOffers',[
  'jquery',
  'lib/util/tda.config',
  'components/offers/offers.filters',
  'lib/getParameterByName',
  'ajaxOffers',
  'responsive',
  'bat',
  'lib/page-cache',
  'inpageHeadline',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'features/favorites',
  'cookies',

  // side effect includes
  'lib/loader/series',
  'lib/transforms/series.mapByCode',
  'lib/helpers/offer-bundle',
  'jqueryui',
  'componentIsotope'
], function (
  $,
  tdaConfig,
  IsotopeFilters,
  getParameterByName,
  AjaxOffers,
  responsive,
  bat,
  PageCache,
  inpageHeadline,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  favorites,
  cookies
) {
  var __SERIES_MAP = [];
  var __initialized = false;
  var __hasRtiDealer = cookies.getItem('dealer_code_rti') === 'true';

  var allOffers = allOffers || {
    promoItemsMap: {},

    init: function () {
      var self = this;
      self.promoItemsMap = {};
      self.isOffersPage = !!$('div[data-component-skin="All-Offers"]').length;
      self.offerFrame = !!$('div[data-component-skin="Framed Offers"]').length;

      if ($('#filter-promotions').length) {
        var promoItems = $('#filter-promotions div input');
        promoItems.each(function (index, element) {
          var elItem = $(element);
          self.promoItemsMap[elItem.attr('data-name')] = elItem.attr('data-param-value');
        });
      }

      $('body').on('click', '.offer-card-in-iframe', function (e) {
        e.preventDefault();
        var id = $(this).closest('.card').attr('id');
        var $modalInner = $('#offer-card-in-iframe-modal-inner');
        var data = bat.OFFER_DETAIL_MODAL[id];
        var handlebarsHTML = Handlebars.hcompile($('#template-offer-detail-modal').html(), data);
        $modalInner.empty().append(handlebarsHTML);
        $('#print_detail img').attr('style', '');
        $('#offer-card-in-iframe-modal').modal('show');
      });

      var $isotopeContainer = $('#isotope-offers');
      var $isotopePrintContainer = $('#print-isotope-offers');
      var elements = [];
      var offerURLParams;

      $('#print-isotope-offers').hide();
      $isotopeContainer.isotope('remove', $isotopeContainer.find('.isotope-item')); // remove xsl cards

      function formatDate(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm.toUpperCase();
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + strTime;
      }
      /**
         * This function retrieves attribute values that are based on datums
         * and stores them in a hash that maps them to the names of query
         * string parameters used by the 'allOffers' URI
         * (the datum names are not a 1:1 match with URI parameters,
         *  hence this function)
         */
      function setOfferURLParams(attrName, paramName) {
        var attrVal = $('#all-offers').attr('data-' + attrName);
        var url_attr_param = getParameterByName(paramName);

        if (url_attr_param != null && url_attr_param !== '') {
          offerURLParams += '&' + paramName + '=' + url_attr_param;
        } else if (attrVal != null && attrVal !== '') {
          offerURLParams += '&' + paramName + '=' + attrVal;
        }
      }
      offerURLParams = '';
      setOfferURLParams('labelcode', 'offerLabels');
      setOfferURLParams('series', 'series');
      setOfferURLParams('zipcode', 'zipCode');
      setOfferURLParams('offertype', 'offerType');

      var qFilters = getParameterByName('filters');
      var featured = false;
      if (qFilters && qFilters.length) {
        featured = qFilters.indexOf('featured') !== -1;
      }

      var includedParams = '';
      if (self.isOffersPage || self.offerFrame) {
        inpageHeadline.init();
        // BAT-2980 GRAB QUERY PARAMS TO BUILD PROPER REQUEST PARAMS.
        // BAT-3593 added offerFrame check.
        if (qFilters && qFilters.length) {
          var qStore = qFilters.split(',');
          var qParasString = '';
          var qType;
          var qItem;
          var qChunk;

          for (var k = 0; k < qStore.length; k += 1) {
            qItem = qStore[k];
            var mappedPromoItem = self.promoItemsMap[qItem];
            if (qItem === 'featured') {
              // ingore this.
              qType = 'featured';
              qItem = featured.toString();
              // continue;
            }
            if (__SERIES_MAP[qItem]) {
              qType = featured ? 'featuredSeries' : 'series';
            } else if (qItem === 'apr' || qItem === 'cash' || qItem === 'lease' || qItem === 'msrp' || qItem === 'misc') { // "apr", "cash", "lease", "msrp", "misc"
              qType = featured ? 'featuredType' : 'offerType';
            } else if (mappedPromoItem) {
              // BAT-3593: IF THE FILTER PARAMS ARE NOT of type 'series' or 'offerType', WE NEED TO LOOK UP THEIR VALUE
              qType = 'offerLabels';
              qItem = self.promoItemsMap[qItem];
            }
            qChunk = '&' + qType + '=' + qItem;
            qParasString += qChunk;
          }

          if (qParasString.length) {
            // offerURLParams = '&offerType=apr&series=yaris';
            // can we just pass these as url params so we don't change the service url here?
            // offerURLParams = qParasString; //DO NOT USE THIS, IT FORCES IT ONTO THE BASEURL.
            includedParams = qParasString;
          }
        }
      }

      var offersServiceUrl = '/offers-service/OFFERS/allOffers?pageSize=9' + offerURLParams;
      // BAT-2980. pass in query params to allOffersAjax instance, allowing it to create a search with filters:
      var allOffersAjax = new AjaxOffers(offersServiceUrl, true, true, $('#template-offer-card'), $isotopeContainer, null, includedParams);
      var allOffersPrintAjax = new AjaxOffers('/offers-service/OFFERS/allOffers?' + offerURLParams, true, true, $('#template-offer-card'), $isotopePrintContainer);
      var allOffersCompleteAjax = new AjaxOffers('/offers-service/OFFERS/allOffers?' + offerURLParams, true, true, $('#template-offer-card'), $isotopeContainer);

      allOffersAjax.init();
      var allOffersFilters = new IsotopeFilters(allOffersAjax, true);

      if ($('#print-isotope-offers').length) {
        allOffersPrintAjax.init();
      }

      $(allOffersAjax).on('COMPLETE', function allOffersAjaxComplete(event, $newItems, data) {
        if ($('#filters-panel').length === 0 && responsive() === 'lg') {
          $('#right-side').each(function () {
            this.style.setProperty('width', '100%', 'important');
          });
          $('#grid-button').hide();
          $('#list-button').hide();
          $('#right-side').css('margin-top', '30px');
        }

        var currentPageUrl = window.location.pathname;
        $('.total-found').html(data.numFound);
        $isotopeContainer.isotope('insert', $newItems);
        $isotopeContainer.isotope({
          sortBy: 'label'
        });

        $('#showing-number-of-total .number').html($isotopeContainer.children('.isotope-item:not(.isotope-hidden)').length);

        self.textFitOfferCards();
        allOffersAjax.checkDisplayShowMore();

        // Adding toggle for TDA to control this behavior GNY-199
        if (($('#defaultzipcode').attr('singleofferredirect') !== 'No') && (window.location.href.indexOf('teamsite') === -1)) {
          /* Send user directly to offer-detail page, when these conditions are met
          TODO: Since Domain Restructure, it's possible for these conditions to be met on the homepage & it looks like we wanted to prevent that
          */
          if (currentPageUrl !== '/en/#' && currentPageUrl !== '/en/' && currentPageUrl.indexOf('Home.page') === -1 && currentPageUrl.indexOf('dealer_offers_frame') === -1 && $('.total-found').html() === '1') {
            var offerId = $('.isotope-item:not(.isotope-hidden)').attr('id');
            if (offerId !== '' && offerId !== null && offerId !== 'undefined' && typeof offerId !== 'undefined' && $.trim(offerId) !== '') {
              // Redirecting when single offer = terrible idea
              window.location.href = '/' + tdaConfig.site.context_url + '/offer-detail/?offerid=' + offerId;
            }
          }
        }
        // BAT-4780
        $(document).trigger('COMPLETE_FINISH', {
          data: data
        });

        self.analyticsContext(data.numFound, allOffersFilters.allIsotopeFilters);
        __initialized = true;
        self.favListeners();
      });

      $(allOffersPrintAjax).on('COMPLETE', function (event, $newItems, data) {
        // CHI-168
        // Move the code to add the elements to the isotopePrintContainer
        // to the onclick for printing offers, this will get rid of the
        // console error and will not make page hang when loading
        $.each($newItems, function (ind, val) {
          var element = $(val).get(0);
          elements.push(element);
        });
      });

      // when the hell does this one go Down, if allOffersCompleteAjax is completely overwritten on
      // display-all-offers click below?
      $(allOffersCompleteAjax).on('COMPLETE', function (event, $newItems, data) {
        $isotopeContainer.isotope('remove', $isotopeContainer.find('.isotope-item'));
        $isotopeContainer.isotope('insert', $newItems);
        $isotopeContainer.isotope({
          sortBy: 'label'
        });
        self.textFitOfferCards();
        $('#showing-number-of-total .number').html(data.numFound);
        allOffersCompleteAjax.checkDisplayShowMore();
        $('.total-found').html(data.numFound);
        $('#nav-links').css('transform', $('div.card:eq(0)').css('transform'));
        $('#nav-links').css('width', $('div.card:eq(0)').css('width'));
        $('#nav-links').find('a').css('border-top', 'none');
        $('#nav-links').find('ul').css('border-bottom', 'none');
        $('#nav-links').css('border-bottom', 'none');

        if (responsive() === 'md') {
          $('#nav-links').css('width', '490px');
        }
        // BAT-4780
        $(document).trigger('COMPLETE_FINISH', {
          data: data
        });
      });

      $(allOffersAjax).on('NO_ITEMS_FOUND', function () {
        allOffersAjax.checkNoItemsFound();
        self.analyticsContext('0', allOffersFilters.allIsotopeFilters);
      });

      $('#show-more-button').click(function (e) {
        e.preventDefault();
        allOffersAjax.showMore();
        allOffersAjax.init();
        var currentOffersNum = parseInt($('.legend-center').find('.number').text());
        var numResults = parseInt($('.legend-center').find('.number').text()) + 9;
        var totalResults = parseInt($('.legend-center').find('.total-found').text());
        if (numResults > totalResults) {
          numResults = totalResults;
        }

        // BAT-4780 SELECT THE FIRST ITEM OF THE LAST BATCH FETCHED ( FOR ADA SRT/ KEYBOARD )
        $(document).off().on('COMPLETE_FINISH', function (e, opts) {
          setTimeout(function () {
            // GIVE IT A SECOND OR TWO TO DRAW.
            var nextOffer = $('#isotope-offers .card.offer').eq(currentOffersNum).find('a'); // .find('.favorite-button'); // .find('a');
            nextOffer.focus();
          }, 2000);
        });

        // BAT-2980. update offer links with filters.
        allOffersFilters.combineFilters();
      });

      // This is crazy, why are we duplicating funcationality here?
      $('#display-all-offers').click(function (e) {
        e.preventDefault();
        var currentOffersNum = parseInt($('.legend-center').find('.number').text());
        allOffersFilters.clearFilters();
        allOffersCompleteAjax.serviceUrl = allOffersAjax.serviceUrl.replace('pageSize=9&', '').replace('&startIndex=9', '');
        allOffersCompleteAjax = new AjaxOffers(allOffersCompleteAjax.serviceUrl, true, true, $('#template-offer-card'), $isotopeContainer);

        $(document).off().on('COMPLETE_FINISH', function (e, opts) { // BAT-4905
          setTimeout(function () {
            // GIVE IT A SECOND OR TWO TO DRAW.
            var nextOffer = $('#isotope-offers .card.offer').eq(currentOffersNum).find('a'); // .find('.favorite-button'); // .find('a');
            nextOffer.focus();
          }, 2000);
        });

        $(allOffersCompleteAjax).on('COMPLETE', function (event, $newItems, data) {
          $isotopeContainer.isotope('remove', $isotopeContainer.find('.isotope-item'));
          $isotopeContainer.isotope('insert', $newItems);
          $isotopeContainer.isotope({
            sortBy: 'label'
          });
          self.textFitOfferCards();
          $('#showing-number-of-total .number').html(data.numFound);
          allOffersCompleteAjax.checkDisplayShowMore();
          $('.total-found').html(data.numFound);

          $(document).trigger('COMPLETE_FINISH', { // BAT-4905
            data: data
          });
          self.favListeners();
          // BAT-2980. update offer links with filters.
          allOffersFilters.combineFilters();
        });
        allOffersCompleteAjax.init();
      });

      $('#print_dealer_frame').on('click', function () {
        // CHI-168
        // This code was above in the on COMPLETE, but moved
        // here to get rid of the console errors, and to not
        // make the page hang when loading
        try {
          $isotopePrintContainer.isotope('insert', elements);
          $isotopePrintContainer.isotope({
            sortBy: 'label'
          });
          self.textFitOfferCards();
          setTimeout(function () {
            $('#nav-links').css('transform', $('div.card:eq(0)').css('transform'));
          }, 1000);
        } catch (e) {
          // The actual error is: TypeError: .card is not a function
          // but this seems to be a bug in isotope with no real solution,
          // reference: https://github.com/metafizzy/isotope/issues/111
          // Don't log anything so there are no messy errors in the console
          // lad
          // console.log(e.message);
        }

        var divs = $('#print-isotope-offers').find('.isotope-item').filter(function (index) {
          return $(this).css('opacity') === '1';
        });

        var wrapClass = $('#print-isotope-offers').find('.isotope-item:eq(0)').parent().attr('class');

        if (wrapClass != null && wrapClass != '' && $.trim(wrapClass) != '' && typeof wrapClass !== 'undefined' && wrapClass == 'page-break-offers') {
          $('.page-break-offers').children('div.isotope-item').unwrap();
        }
        for (var i = 0; i < divs.length; i += 6) {
          divs.slice(i, i + 6).wrapAll('<div class="page-break-offers"></div>');
        }

        var d = new Date();
        var e = formatDate(d);
        var newWindow = window.open('', 'Test', 'width=800,height=800,scrollbars=1,resizable=1');
        var html = '<!DOCTYPE html><html><head><META http-equiv="Content-Type" content="text/html; charset=UTF-8"><title>Toyota Dealer Association Offers Frame</title><link href="/assets/css/all.css" rel="stylesheet" type="text/css"><link href="/assets/css/print-offers.css" rel="stylesheet" type="text/css"></head><body><div id="" style="width: 950px; height: 60px; background-image: url(http://www.cincinnati.buyatoyota.com/img/landing/dealer_offers_frame/headerBG.jpg); background-repeat: repeat-x;" class=""><span><p><img height="60" width="456" alt="Frame Banner" src="http://www.cincinnati.buyatoyota.com/img/landing/dealer_offers_frame/movingForwardLogo.jpg" title="Toyota Page Banner"></p></span></div><p><span style="color: #9a0f14; font-family: Verdana, Geneva, sans-serif; font-size: 24px; font-style: normal; font-variant: normal; font-weight: bold; letter-spacing: normal; line-height: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-stroke-width: 0px; display: inline !important; float: none;">TOYOTA SPECIAL OFFERS</span></p>Printed - <span id="curr_time">' + e + '</span><div style="float:none !important" class="pull-right-md pull-left-sm marg-right-4-sm"><span class="font-3 found"><span class="total-found font-bold">' + $('#print-isotope-offers').find('div.card').length + '</span><span class="font-light color-light plural"> offers found</span></div><div id="isotope-offers" class="isotope-container run-isotope grid layout-lg isotope" style="position: relative; overflow: hidden; height: ' + $('#print-isotope-offers').css('height') + ';">' + $('#print-isotope-offers').html() + '</div>';
        newWindow.document.open();
        newWindow.document.write(html);
        newWindow.document.close();
        setTimeout(function () {
          newWindow.print();
        }, 1500);
      });

      anClicks(this.getScope());
    },

    getScope: function () {
      var $vehiclePage = $('#offers-vehicle-page');
      if (this.offerFrame) {
        return $('div[data-component-skin="Framed Offers"]');
      }
      if ($vehiclePage.length) {
        // TODO: stop doing this data shuffle on the side
        // argggh. that km-rab-download link needs to be moved and styled in the XSL
        $vehiclePage.parent('div').data('anctx', $vehiclePage.data('anctx'));
        return $vehiclePage.parent('div');
      }
      return $('#all-offers'); // handles the homepage skin or all-offers skin
    },

    analyticsContext: function (count, filters) {
      var strFilters = filters.join(',');
      var finalFilters = strFilters === '*' ? '' : strFilters.replace(/\./g, '');
      var $scope = this.getScope();
      anAddContext(
        $scope,
        blocks.offerListBlock({
          count: count,
          layout: $('#list-button').hasClass('active') ? 'list' : 'grid',
          filter: finalFilters,
          selector: finalFilters
        })
      );
      if (__initialized) {
        anPageLoad($scope);
      } else {
        anPageLoad($scope, blocks.keyMetrics('km-offers-search'));
      }
    },

    favListeners: function () {
      var $scope = this.getScope();
      var $favButton = $('.favorite-button', $scope);
      if (__hasRtiDealer) {
        $favButton.hide();
      } else {
        $favButton.each(function () {
          var $this = $(this);
          favorites.markFav($this);
          $this.off('click.fav').on('click.fav', function favClick(e) {
            e.preventDefault();
            favorites.addRemove($this);
          });
        });
      }
    },

    // TODO: get rid of this garbage
    textFitOfferCards: function () {
      $('.card .trim.textfit, .card .name.textfit').each(function (index, item) {
        // BAT-2757.
        $(item).removeAttr('style');
        setTimeout(function () {
          var tow = $(item).outerWidth();
          var offertypeWidth = 0;
          var siblings = $(item).siblings();
          siblings.each(function (idx, sib) {
            sib = $(sib);
            // OFFER-TYPE
            if (sib.hasClass('offer-type')) {
              offertypeWidth = sib.width(); // NEED THIS FOR CALCS.
            }
            // MODEL
            if (sib.hasClass('model') || sib.hasClass('trim')) {
              var mow = sib.outerWidth();
              /*
                tow =  the item width
                mow = .model width
                offertypeWidth = the width of the offer type element.  it is 100% so we grab that width to measure against.
              */
              if (mow + tow > offertypeWidth) {
                $(item).css('width', '100%');
                $(item).css('display', 'block');
              } else {
                $(item).css('width', 'auto');
                $(item).css('display', 'inline');
              }
            }
          });
        }, 500);
      });
      // BAT-2760, .textfit plugin now works, we can use it on .descriptions (only present on MISC offers)
      $('.card .description.textfit').textFit({
        alignHoriz: false,
        // alignVert: true,
        minFontSize: 13,
        maxFontSize: 20,
        alignVertWithFlexbox: true
      });
    }
  };

  // TODO: move to inline XSL(s)
  $(document).ready(function () {
    if ($('#isotope-offers').length) {
      PageCache.await('series.map')
        .then(function (seriesMap) {
          __SERIES_MAP = seriesMap;
          allOffers.init();
        });
    }
  });
});

